import * as React from 'react';
import { useSelector } from 'react-redux';

import { TourButton } from '../../../components/NewbuildingTiledCarousel/TourButton';
import { selectIs3dToursExperimentActive } from '../../../selectors/abExperiments/selectIs3dToursExperimentActive';
import { virtualTourKeySelector } from '../../../selectors/newObject/getTour';
import { trackTourButtonClick } from './tracking';

export const TourButtonContainer = () => {
  const isEnabled = useSelector(selectIs3dToursExperimentActive);
  const tour = useSelector(virtualTourKeySelector);

  const handler = React.useCallback(() => {
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    document.getElementById('tourBlock')!.scrollIntoView({ block: 'center' });
    trackTourButtonClick();
  }, []);

  if (!tour || !isEnabled) {
    return null;
  }

  return <TourButton handler={handler} />;
};

TourButtonContainer.displayName = 'TourButtonContainer';
